import { Box, CircularProgress, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useContext } from 'react'
import Context from '../../Context'
import theme from '../../theme'
import CountBadge from '../../components/CountBadge'

/**
 * Leagues that qualified for a group, each carrying its own sport so the list is not tied to one of them.
 * An empty list is a real answer, not a state of loading: nothing above the threshold has to say so
 * rather than spin for ever.
 */
function GroupLeagues({ groupName, entries, loading, emptyText }) {
  // only the arb list carries a count: there it says how many chances are waiting behind the name
  const { setCurrentLeague, setSelectedEvent, setShowSettings, settings } = useContext(Context)
  const showCount = groupName === 'Arbs' && settings.showCounts

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>
        <CircularProgress color="secondary" size={26} />
      </Box>
    )
  }

  if (!entries.length) {
    return (
      <Box sx={{ padding: '10px 16px 14px' }}>
        <Typography sx={{ color: '#B9BDC1', fontSize: '13px' }}>{emptyText}</Typography>
      </Box>
    )
  }

  const open = (entry) => {
    setSelectedEvent(null)
    setShowSettings(false)
    setCurrentLeague({ group: groupName, sport: entry.sport, league: entry.league })
  }

  return (
    <List component="div" sx={{ backgroundColor: theme.palette.primary.main }} disablePadding>
      {entries.map((entry) => (
        <ListItem key={`${entry.sport}-${entry.league}`} disablePadding>
          <ListItemButton onClick={() => open(entry)} sx={{ pl: 4 }}>
            <ListItemText
              sx={{ color: theme.palette.primary.contrastText }}
              primary={entry.league}
              secondary={entry.sport}
              secondaryTypographyProps={{ sx: { color: '#8E9398', fontSize: '11px' } }}
            />
            {showCount && <CountBadge count={entry.count} />}
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  )
}

export default GroupLeagues
